// i18n
export const CHANGE_LANG = 'CHANGE_LANG'

// Globals
export const REMOVE_DATA = 'REMOVE_DATA'
export const SET_SHOW_VERSION = 'SET_SHOW_VERSION'
export const SET_ICON_THEME = 'SET_ICON_THEME'
export const SET_CONFIG_URL = 'SET_CONFIG_URL'
export const SET_CONFIG_SOCKET_URL = 'SET_CONFIG_SOCKET_URL'

// Permission
export const SET_LOGIN_ACCOUNT_INFO = 'SET_LOGIN_ACCOUNT_INFO'
export const SET_LOGIN_ACCOUNT_PERMISSION = 'SET_LOGIN_ACCOUNT_PERMISSION'

//Sidebar
export const RESET_SIDE_MENU = 'RESET_SIDE_MENU'
export const SET_SIDE_MENU_LOADING = 'SET_SIDE_MENU_LOADING'
export const SET_SIDE_MENU = 'SET_SIDE_MENU'
export const SET_SIDE_MENU_PROMPT = 'SET_SIDE_MENU_PROMPT'
export const SET_MENU = 'SET_MENU'

// Socket
export const SUBSCRIBE_SOCKET = 'SUBSCRIBE_SOCKET'
export const UNSUBSCRIBE_SOCKET = 'UNSUBSCRIBE_SOCKET'
export const SET_SUBSCRIBE_EVENTS = 'SET_SUBSCRIBE_EVENTS'
export const SET_SUBSCRIBE_RESPONSE = 'SET_SUBSCRIBE_RESPONSE'
export const CLOSE_SOCKET = 'CLOSE_SOCKET'

// System
export const SET_SYSTEM_MAINTENANCE = 'SET_SYSTEM_MAINTENANCE'
export const CHECK_SYSTEM_MAINTENANCE = 'CHECK_SYSTEM_MAINTENANCE'
export const HANDLE_SYSTEM_ANNOUNCEMENT = 'CHECK_SYSTEM_ANNOUNCEMENT'
export const CHECK_ADDRESS_NOTIFY = 'CHECK_ADDRESS_NOTIFY'
export const SET_SYSTEM_ANNOUNCE_OPENED = 'SET_SYSTEM_ANNOUNCE_OPENED'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const RESET_MESSAGE = 'RESET_MESSAGE'
